<template>
  <div>
    <el-form class="toolbar" :inline="true" @keyup.enter.native="pageIndex = 1; load()">
      <el-form-item label="主物料">
        <el-select v-model="query.materialId" placeholder="请选择主物料" size="small" filterable clearable style="width:280px">
          <el-option v-for="item in materials" :key="item.materialId" :label="item.materialCode + ' / ' + item.materialName" :value="item.materialId" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('base:materialUnit:list')" type="primary" size="small" @click="pageIndex = 1; load()">查询</el-button>
      </el-form-item>
      <el-form-item style="float:right">
        <el-button v-if="isAuth('base:materialUnit:save')" type="primary" size="small" @click="open()">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list" border v-loading="loading" style="width:100%" :header-cell-style="headStyle">
      <el-table-column type="index" label="序号" header-align="center" align="center" width="60" />
      <el-table-column prop="materialCode" label="主物料编码" header-align="center" align="left" min-width="130">
        <template slot-scope="scope">
          <a v-if="isAuth('base:materialUnit:info')" class="code-link" @click="open(scope.row, true)">{{ scope.row.materialCode }}</a>
          <span v-else>{{ scope.row.materialCode }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="materialName" label="主物料名称" header-align="center" align="left" min-width="150" show-overflow-tooltip />
      <el-table-column prop="unitName" label="库存单位" header-align="center" align="left" width="110" />
      <el-table-column prop="convertUnitName" label="换算单位" header-align="center" align="left" width="110" />
      <el-table-column prop="convertInventory" label="换算数量" header-align="center" align="right" width="110" />
      <el-table-column prop="directionName" label="换算方向" header-align="center" align="center" width="100" />
      <el-table-column prop="sort" label="排序" header-align="center" align="center" width="80" />
    </el-table>
    <el-pagination class="list-pagination" @size-change="val => { pageSize = val; pageIndex = 1; load() }"
      @current-change="val => { pageIndex = val; load() }" :current-page="pageIndex" :page-sizes="[20, 50, 100]"
      :page-size="pageSize" :total="total" layout="total, sizes, prev, pager, next, jumper" />

    <el-dialog :visible.sync="visible" width="min(640px, calc(100vw - 24px))" :close-on-click-modal="false">
      <template slot="title">
        <div class="doc-dialog-header">
          <span class="doc-dialog-title">{{ dialogTitle }}</span>
          <div v-if="readonly && form.materialUnitId" class="doc-dialog-actions">
            <el-button-group>
              <el-button v-if="isAuth('base:materialUnit:update')" type="primary" size="small" @click="readonly = false">修改</el-button>
              <el-button v-if="isAuth('base:materialUnit:delete')" type="danger" size="small" @click="remove">删除</el-button>
            </el-button-group>
          </div>
        </div>
      </template>
      <el-form ref="dataForm" :model="form" :rules="readonly ? {} : rules" label-width="110px" :disabled="readonly">
        <el-form-item label="主物料" prop="materialId">
          <el-select v-model="form.materialId" filterable style="width:100%">
            <el-option v-for="item in materials" :key="item.materialId" :label="item.materialCode + ' / ' + item.materialName" :value="item.materialId" />
          </el-select>
        </el-form-item>
        <el-form-item label="库存单位" prop="unit">
          <el-select v-model="form.unit" filterable style="width:100%">
            <el-option v-for="item in unitOptions" :key="item.id" :label="item.dictLabel" :value="String(item.id)" />
          </el-select>
        </el-form-item>
        <el-form-item label="换算单位" prop="convertUnit">
          <el-select v-model="form.convertUnit" filterable style="width:100%">
            <el-option v-for="item in unitOptions" :key="'c' + item.id" :label="item.dictLabel" :value="String(item.id)" />
          </el-select>
        </el-form-item>
        <el-form-item label="换算数量" prop="convertInventory"><el-input v-model="form.convertInventory" /></el-form-item>
        <el-form-item label="换算方向">
          <el-radio-group v-model="form.direction">
            <el-radio label="0">数量在右</el-radio>
            <el-radio label="1">数量在左</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序"><el-input-number v-model="form.sort" :min="0" :step="1" style="width:100%" /></el-form-item>
        <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :rows="2" /></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">关闭</el-button>
        <el-button v-if="!readonly" type="primary" @click="save">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'

export default {
  name: 'MaterialUnit',
  data() {
    return {
      query: { materialId: '' },
      materials: [], unitOptions: [], list: [], pageIndex: 1, pageSize: 20, total: 0, loading: false,
      visible: false, readonly: false, permCodes: [], form: {},
      headStyle: { background: '#f5f7fa', color: '#606266' },
      rules: {
        materialId: [{ required: true, message: '主物料不能为空', trigger: 'change' }],
        unit: [{ required: true, message: '库存单位不能为空', trigger: 'change' }],
        convertUnit: [{ required: true, message: '换算单位不能为空', trigger: 'change' }],
        convertInventory: [{ required: true, message: '换算数量不能为空', trigger: 'blur' }]
      }
    }
  },
  computed: {
    dialogTitle() {
      if (this.readonly) return '查看单位换算'
      return this.form.materialUnitId ? '修改单位换算' : '新增单位换算'
    }
  },
  created() {
    this.loadPerms()
    this.loadMaterials()
    this.loadUnits()
    this.load()
  },
  activated() {
    this.loadMaterials()
  },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    loadMaterials() {
      request.post('/base/material/page', { currentPage: 1, pageSize: 500 }).then(res => {
        this.materials = (res.data && res.data.list) || []
      }).catch(() => {})
    },
    loadUnits() {
      request.get('/sys/dicts', { params: { dictType: 'MATERIAL_UNIT' } }).then(res => {
        this.unitOptions = res.data || []
      }).catch(() => {})
    },
    load() {
      this.loading = true
      request.post('/base/materialUnit/list', {
        currentPage: this.pageIndex, pageSize: this.pageSize, materialId: this.query.materialId || ''
      }).then(res => {
        const data = res.data || {}
        this.list = data.list || []
        this.total = data.totalCount || 0
      }).catch(() => { this.list = []; this.total = 0 }).finally(() => { this.loading = false })
    },
    open(row, readonly) {
      this.readonly = !!readonly
      this.visible = true
      const blank = () => ({
        materialUnitId: '', materialId: this.query.materialId || '', unit: '', convertUnit: '',
        convertInventory: '1', direction: '0', isMain: '0', sort: 0, remark: ''
      })
      if (!row || !row.materialUnitId) {
        this.form = blank()
        this.$nextTick(() => { this.$refs.dataForm && this.$refs.dataForm.clearValidate() })
        return
      }
      request.get('/base/materialUnit/info/' + row.materialUnitId).then(res => {
        this.form = Object.assign(blank(), res.data || row)
        this.$nextTick(() => { this.$refs.dataForm && this.$refs.dataForm.clearValidate() })
      }).catch(() => {
        this.form = Object.assign(blank(), row)
      })
    },
    save() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        if (!Number.isFinite(Number(this.form.convertInventory)) || Number(this.form.convertInventory) <= 0) {
          this.$message.warning('换算数量必须大于0')
          return
        }
        if (this.form.unit === this.form.convertUnit) {
          this.$message.warning('换算单位不能与库存单位相同')
          return
        }
        const path = this.form.materialUnitId ? '/base/materialUnit/update' : '/base/materialUnit/save'
        request.post(path, this.form).then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.load()
        }).catch(() => {})
      })
    },
    remove() {
      this.$confirm('确定删除该单位换算?', '提示', { type: 'warning' }).then(() => {
        request.post('/base/materialUnit/delete', { materialUnitId: this.form.materialUnitId }).then(() => {
          this.$message.success('删除成功')
          this.visible = false
          this.load()
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.list-pagination { margin-top: 12px; text-align: right; }
.toolbar >>> .el-form-item { margin-bottom: 8px; }
.code-link { color: #348adb; cursor: pointer; }
.doc-dialog-header { display: flex; align-items: center; justify-content: space-between; padding-right: 28px; }
.doc-dialog-title { font-size: 16px; font-weight: 600; }
</style>
